"use client";
import n from "styled-components";
import t from "react";
import { Chart as s, ArcElement as m, DoughnutController as l } from "./index.es222.js";
import { Chart as d } from "./index.es223.js";
import { toRgba as o } from "./index.es99.js";
s.register(m, l);
const u = n.div`
  display: flex;
  justify-content: center;
`, c = n.div`
  position: relative;
  width: 8.175rem;
  height: 8.175rem;
  max-width: 8.175rem;
  max-height: 8.175rem;
  min-width: 8.175rem;
  min-height: 8.175rem;
`, h = n.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
`, p = n.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
`, E = ({ value: i, color: e }) => {
  const r = {
    options: {
      cutout: "62%",
      maintainAspectRatio: !0
    },
    datasets: [
      {
        data: [i, 100 - i],
        backgroundColor: [o(e), o(e, 0.4)],
        borderWidth: 0
      }
    ]
  }, a = e === "ocre" || e === "sand" ? "bl-text-neutral-1" : `bl-text-${e}-1`;
  return /* @__PURE__ */ t.createElement(u, { className: a }, /* @__PURE__ */ t.createElement(c, null, /* @__PURE__ */ t.createElement(h, null, /* @__PURE__ */ t.createElement(
    d,
    {
      type: "doughnut",
      width: 100,
      height: 100,
      data: r,
      "aria-hidden": !0,
      options: {
        cutout: "67%",
        aspectRatio: 1,
        maintainAspectRatio: !1,
        responsive: !0
      }
    }
  )), /* @__PURE__ */ t.createElement(p, null, /* @__PURE__ */ t.createElement("div", { className: "bl-size-3" }, `${i}%`))));
};
export {
  E as Donut
};
//# sourceMappingURL=index.es101.js.map
